export default __webpack_public_path__ + "media/images/icons/mail-bca23c2ff977837cacfb736ea4e698e8.svg";